// direct_upload.js
//
// Global fallback logger for direct upload lifecycle events.
// The master_mockups form uses the `psd-upload` Stimulus controller instead,
// which provides progress UI, disabled-state management, and inline errors.
// This file is kept only for console visibility during development.

addEventListener("direct-upload:initialize", ({ detail: { file } }) => {
  console.log(`[DirectUpload] Starting: ${file.name} (${(file.size / 1024 / 1024).toFixed(1)} MB)`)
})

addEventListener("direct-upload:progress", ({ detail: { progress } }) => {
  console.log(`[DirectUpload] Progress: ${Math.round(progress)}%`)
})

addEventListener("direct-uploads:end", () => {
  console.log("[DirectUpload] All uploads complete")
})
